import React, { Component, Fragment } from "react";
import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import Spinner from "./Spinner";

class MyForm extends Component {
  constructor(props) {
    super(props);

    let params = new URLSearchParams(window.location.search),
      arParams = [];

    for (let name of params.keys()) {
      arParams.push({
        name,
        value: params.get(name)
      });
    }

    this.state = {
      uid: params.get("uid"),
      file: null,
      arParams,
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmitButton = this.handleSubmitButton.bind(this);
  }

  handleChange(event) {
    let name = "";
    if (event.target.files[0].size <= 15728640) {
      if (event.target.files[0]) {
        name = event.target.files[0].name;
      }
      if (name.length > 20) {
        name = name.slice(0, 20) + "...";
      }
      this.setState({ file: name });
    } else {
      event.target.value = "";
      alert("Изображение должно быть меньше 15 мегабайт");
    }
  }

  handleSubmitButton() {
    this.setState({ loading: true });
    setTimeout(() => {
      const paramsUrl = new URLSearchParams(window.location.search);
      paramsUrl.set(
        "error",
        "При отправке запроса произошла ошибка. Попробуйте повторить попытку."
      );
      const query = paramsUrl.toString() ? "?" + paramsUrl.toString() : "";

      window.location.href =
        window.location.origin + window.location.pathname + query;
    }, 60 * 1000);
  }

  render() {
    const { loading } = this.state;
    const { allow_screenshot, allow_message, article_id, en } = this.props;
    return (
      <Fragment>
        {loading && <Spinner />}
        <Form
          method="POST"
          encType="multipart/form-data"
          className="form"
          onSubmit={this.handleSubmitButton}
        >
          {this.props.article_id && (
            <Input type="hidden" name="article_id" value={article_id} />
          )}
          {!this.state.uid && (
            <FormGroup>
              <Label for="mail" className="label label_bold">
                {en ? 'Email' : 'Почта'}
              </Label>
              <Input name="mail" id="mail" required pattern=".+@.+" />
            </FormGroup>
          )}
          {allow_message && (
            <FormGroup>
              <Label for="comment" className="label label_bold">
                {en ? 'Your request' : 'Написать'}
              </Label>
              <Input type="textarea" name="comment" id="comment" required />
            </FormGroup>
          )}
          {allow_screenshot && (
            <FormGroup className="screenshot float-right">
              <Input
                type="file"
                name="file"
                id="file"
                accept="image/*"
                onChange={this.handleChange}
              />
              <Label for="file" className="label">
                {this.state.file ? this.state.file : en ? "Add screenshot" : "Добавить скриншот"}
              </Label>
            </FormGroup>
          )}
          <Button color="success">{en ? 'Send' : 'Отправить'}</Button>
        </Form>
      </Fragment>
    );
  }
}

export default MyForm;



// WEBPACK FOOTER //
// ./src/MyForm.js